var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardTopbarChIconWhite = function SvgNewcsDashboardTopbarChIconWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_topbar_ch_icon_white_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#707070",
    d: "M153 342h22v22h-22z",
    "data-name": "\\u77E9\\u5F62 324"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_topbar_ch_icon_white_svg__a)",
    transform: "translate(-153 -342)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 20,
    fill: "#fff",
    "data-name": "\\u77E9\\u5F62 230",
    rx: 4,
    transform: "translate(153 343)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393157",
    d: "M160.73 350.08a2.2 2.2 0 0 0-1.23.345 2.27 2.27 0 0 0-.825.99 3.6 3.6 0 0 0-.295 1.515 3.5 3.5 0 0 0 .605 2.24 2.13 2.13 0 0 0 1.765.75 1.9 1.9 0 0 0 1.34-.53 2.5 2.5 0 0 0 .72-1.44h.94a3.54 3.54 0 0 1-.55 1.52 2.85 2.85 0 0 1-1.1.975 3.2 3.2 0 0 1-1.47.335 3.2 3.2 0 0 1-1.7-.45 2.97 2.97 0 0 1-1.145-1.31 4.8 4.8 0 0 1-.405-2.05 4.5 4.5 0 0 1 .41-1.97 3.06 3.06 0 0 1 1.17-1.315 3.3 3.3 0 0 1 1.77-.465 3.4 3.4 0 0 1 1.425.29 2.65 2.65 0 0 1 1.035.82 2.55 2.55 0 0 1 .49 1.24h-.94a1.76 1.76 0 0 0-.67-1.1 2.2 2.2 0 0 0-1.34-.39m8.92 2.3v-2.97h.97v7.18h-.97v-3.35h-3.75v3.35h-.97v-7.18h.97v2.97Z",
    "data-name": "\\u8DEF\\u5F84 251"
  }))));
};
export default SvgNewcsDashboardTopbarChIconWhite;